const editContent = {
  beforeMount (element, _binding, vnode) {
    element.contenteditable = false
    element.spellcheck = false
    element.addEventListener('dblclick', function () {
      this.contentEditable = true
      this.classList.add('edit-content-active')
      this.focus()
    })
    element.addEventListener('focus', function () {
      document.execCommand('selectAll', false, null)
    })
    element.addEventListener('blur', function (event) {
      this.contentEditable = false
      this.classList.remove('edit-content-active')
      vnode.props.onUpdate(this.innerText)
    })
    element.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        this.contentEditable = false
        this.classList.remove('edit-content-active')
        vnode.props.onUpdate(this.innerText)
        this.blur()
      }
    })
  }
}

export default editContent
